import { FunctionFactory } from "survey-core";

enum Gender {
  Male = "Male",
  Female = "Female",
  NonBinary = "Non-binary",
}


const genderQuestion = {
  name: "gender",
  title: `What gender do you identify with?`,
  description: `Some aspects of your plan adapt based on gender-specific physiology.`,
  descriptionLocation: 'underTitle',
  type: "radiogroup",
  choices: Object.values(Gender),
  isRequired: true,
};

const genderNounExpression = {
  name: "genderNoun",
  expression: "renderGender({gender})",
};

function renderGender(params: any[]): string {
  if (params === undefined || params === null) return "";
  return (params[0] as Gender) === Gender.Female ? "women" : "men";
}

FunctionFactory.Instance.register("renderGender", renderGender);

export { Gender, genderNounExpression, genderQuestion, renderGender };
